// imports for app window layout
import { useAuth0 } from '@auth0/auth0-react';
import MainWindow from '../../app_layout/main_window/MainWindow';
import ChatWindow from '../../app_layout/chat_window/ChatWindow';
import SideBar from '../../app_layout/sidebar/SideBar';
import APP_WINDOW_CONFIG from '../../app_layout/layout_config';

// imports relevant for HTTP calls
import DisplayException from '../../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import {SERVER_URL, WEBSOCKET_URL} from '../../config_server_url';

// import user session information
import UserSessionContext from '../../user_session/context_user_session';

// imports this module specific
import '../../css_styles/button_styles.css'
import classes from './PageCampaignSetup.module.css';
import WorkflowViewer from '../../experimental_setup/WorkflowViewer'
import DesignSpaceViewer from '../../design_space/DesignSpaceViewer'
import ObjectiveViewer from '../../objective/ObjectiveViewer'
import WorkflowEditor from '../../experimental_setup/WorkflowEditor'
import DesignSpaceEditor from '../../design_space/DesignSpaceEditor'
import ObjectiveEditor from '../../objective/ObjectiveEditor'
import InfoPopup from '../../popup_windows/InfoPopup';
import YesNoPopup from '../../popup_windows/YesNoPopup';
import classes2 from '../../popup_windows/YesNoPopup.module.css';

import CampaignValidationTable from '../../current_project/campaign_builder/CampaignValidationTable'
import { SetSessionInfo_ModifyCampaignObjects, 
         SetSessionInfo_ResetModifyCampaignObjects,
         SetSessionInfo_OnDeleteCurrentProject,
         SetSessionInfo_OnDeleteCurrentCampaign,
         SetSessionInfo_OnMarkCurrentOptCampaign } from '../../user_session/session_info_utils';

import { useNavigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';

function PageCampaignSetup() {

    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    // This Component requires to fetches data on first load -> setIsloading(true);
    // This Component does not fetch data on first load -> setIsloading(false);
    const [isLoading, setIsLoading] = useState(false);

    // ------------------ Load User Session Information ---------------------------------
    const usr_session_ctx = useContext(UserSessionContext);
    const { user } = useAuth0();
    const [broadcastProject, setBroadcastProject] = useState([]); //get session notifications via web sockets
    const [broadcastCampaign, setBroadcastCampaign] = useState([]); //get session notifications via web sockets
    const [onOkBroadcastCampaign, setOnOkBroadcastCampaign] = useState(null);

    // ------------------ Add User Session Websockets For Notification Events Across All Tenant (Workspace) Members -----------------------------

    useEffect(() => {
        // Create WebSocket connection`${SERVER_URL}/all_projects/load/`
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_project/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        // Connection opened
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
          };
        // Listen for messages
        ws.onmessage = (event) => {
        //   console.log('Message received:', event.data);
          let parser = event.data.split('__');
          let sender = parser[0]
          let type = parser[1].split('.')[1]
          let project_uuid = parser[2]
          if (type === 'ProjectDelete'){
            if(project_uuid === usr_session_ctx.session_info.uuid_current_project) {
                let new_broadcast = (<>{sender} has deleted <strong>your current project uuid:{project_uuid}</strong></>);
                usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentProject(usr_session_ctx);
                handleUpdateUserSession()
                setBroadcastProject(prevBroadcast => [...prevBroadcast, new_broadcast]);
            }
          }
        };
        // Connection closed
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
          ws.close();
        };
      }, []); // Effect runs when tenant_id or user_id changes


    useEffect(() => {
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_campaign/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
        };
        // Listen for messages
        ws.onmessage = (event) => {
            // console.log('Message received:', event.data);
            let parser = event.data.split('__');
            let sender = parser[0]
            let type = parser[1].split('.')[1]
            let project_uuid = parser[2]
            let campaign_uuid = parser[3]
            if (project_uuid === usr_session_ctx.session_info.uuid_current_project && campaign_uuid === usr_session_ctx.session_info.uuid_current_opt_campaign){
                if (type === 'CampaignDelete'){
                        let new_broadcast = (<>{sender} has deleted <strong>your current campaign uuid:{campaign_uuid}</strong></>);
                        usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
                        handleUpdateUserSession()
                        setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                        setOnOkBroadcastCampaign(() => () => {
                            setBroadcastCampaign([]); // Clear broadcast state
                            setCurrentCampaignExists(false);  // 
                          });
                }
                if (type === 'UpdateCampaignTitle'){
                    let new_broadcast = (<>{sender} has updated the campaign title.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign()
                      });
                }
                if (type === 'UpdateCampaignExperimentalWorkflow'){
                    let new_broadcast = (<>{sender} has updated active Experimental Workflow.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign()
                      });
                }
                if (type === 'UpdateCampaignDesignSpace'){
                    let new_broadcast = (<>{sender} has updated active Design Space.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign()
                      });
                }
                if (type === 'UpdateCampaignObjective'){
                    let new_broadcast = (<>{sender} has updated active Objective.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign()
                      });
                }
                if (type === 'UpdateAsNewCampaignExperimentalWorkflow'){
                    let new_broadcast = (<>{sender} has updated active Experimental Workflow as new object.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign()
                      });
                }
                if (type === 'UpdateAsNewCampaignDesignSpace'){
                    let new_broadcast = (<>{sender} has updated active Design Space as new object.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign()
                      });
                }
                if (type === 'UpdateAsNewCampaignObjective'){
                    let new_broadcast = (<>{sender} has updated active Objective as new object.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign()
                      });
                }
                if (type === 'UpdateAsNewCampaignDesignSpace'){
                    let new_broadcast = (<>{sender} has updated active Design Space as new object.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign()
                      });
                }
                if (type === 'MarkCampaignSetupUnderUpdate'){
                        loadCampaign()
                }
                if (type === 'UnMarkCampaignSetupUnderUpdate'){
                    let new_broadcast = (<>{sender} has updated campaign setup.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign()
                      });
                }
            }
        };
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
        ws.close();
        };
    }, []); // Effect runs when tenant_id or user_id changes





      function handleUpdateUserSession() {
        setIsLoading(true);
        let session_update = {key: 'session_info', value: usr_session_ctx.session_info}
        fetch(`${SERVER_URL}/user_session/update_field/`, {method: 'PUT',
                                                           headers:{'Content-Type':'application/json',
                                                                   'auth0_user': user.sub,
                                                                   'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                                                           body:JSON.stringify(session_update)
        })
        .then((res) => {
        if(!res.ok) {
            throw new Error(`HTTP error ${res.status}`);
        }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false);
        })
            .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
   }


// ------------------ General Window Layout -----------------------------
    
    const [canvasSize, setCanvasSize] = useState({width: 0, height: 0});
    const [layout, setLayout] = useState({sidebar:0, main: 0, chat: 0});
    const [toggleSideBar, setToggleSideBar] = useState(false);

    useEffect(() => {
        function handleResize() {
            let window_height = window.innerHeight;
            let window_width = window.innerWidth;
            let canvas_height = window_height - APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = (window_width - sidebar)*APP_WINDOW_CONFIG.CHAT_WIDTH_RELATIVE;
            chat = Math.max (chat, APP_WINDOW_CONFIG.MIN_CHAT_WIDTH_PX);
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setCanvasSize({width: window_width, height: canvas_height});
            // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
            if(toggleSideBar){
                sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
                main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            }
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        // Set initial height
        handleResize();
        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);
        // Remove event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [toggleSideBar]); // Empty dependency array ensures the effect only runs once


    function handleToggle() {
        // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
        if(!toggleSideBar){
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        else
        {
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        setToggleSideBar(!toggleSideBar);
    }

    // ------------------ Side Bar Content -----------------------------

    const sidebar = (<>
        <SideBar width={layout.sidebar} 
                toggle={toggleSideBar} 
                handle_toggle={handleToggle} 
                active_link='active_campaign_setup' >
        </SideBar>
    </>)

    // ------------------ Main Window Content ----------------------------
    
    const navigate = useNavigate();
    const [campaign, setCampaign] = useState(null);
    const [campaignObjects, setCampaignObjects] = useState(null);
    const [windowSelection, setWindowSelection] = useState('ExperimentalWorkflow');
    const [onUpdate, setOnUpdate] = useState(false); 
    const [currentCampaignExists, setCurrentCampaignExists] = useState(false)
    const [showCycleExistPopup, setShowCycleExistPopup] = useState(false)
    const [editCampaignTitle, setEditCampaignTitle] = useState(false)
    const [isEditor, setIsEditor] = useState(false);
    const [validationWindow, setValidationWindow] = useState(false);
    const [validationMessage, setValidationMessage] = useState([]);
    const [showCreateSuccess, setShowCreateSuccess] = useState(false);
    const [popupDelete, setPopupDelete] = useState(false);
    const [onCloneCreatedObjects, setOnCloneCreatedObjects] = useState({})
    const [popupSuccessullyCloned, setPopupSuccessullyCloned] = useState(false)
    const [setupUpdatedBy, setSetupUpdatedBy] = useState('')


    async function loadCampaign(){
        if (usr_session_ctx.session_info.uuid_current_opt_campaign !== '') { 
            setCurrentCampaignExists(true); 
            setIsLoading(true); // Set loading state to true when fetch begins
            let uuid_opt_campaign = usr_session_ctx.session_info.uuid_current_opt_campaign;
            
            try {
                const res = await fetch(`${SERVER_URL}/current_project/load_optimization_campaign/`, { 
                    method: 'POST',
                    headers: {
                        'Content-Type':'application/json',
                        'uuid_tenant': usr_session_ctx.uuid_tenant
                    },
                    body: JSON.stringify(uuid_opt_campaign)
                });

                if (!res.ok) {
                    setIsLoading(false);
                    throw new Error(`HTTP error ${res.status}`);
                }

                const loaded_campaign = await res.json();
                if(loaded_campaign.msg === ''){
                    setCampaign(loaded_campaign.data);
                    let campaign_objects = {
                        uuid_experimental_setup: loaded_campaign.data.uuid_active_experimental_setup,
                        uuid_design_space: loaded_campaign.data.uuid_active_design_space,
                        uuid_objective: loaded_campaign.data.uuid_active_objective
                    };
                    setCampaignObjects(campaign_objects);
                    const is_updated_by_other = await isCampaignOnModifyByOtherUser(loaded_campaign.data.uuid);
                    if (is_updated_by_other.is_under_update === true){
                        setSetupUpdatedBy(is_updated_by_other.under_update_by)
                    }
                    else{
                        setSetupUpdatedBy('')
                    }
                    setIsLoading(false);
                }
                else{
                    let new_broadcast = (<>Your current campaign does not exist anymore.</>);
                    usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
                    handleUpdateUserSession()
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadCampaign();    
                      });
                    setIsLoading(false); 

                }
            } catch (err) {
                setException(true);
                setIsLoading(false);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            }
        } else { 
            setCurrentCampaignExists(false);
        }
    };



    useEffect(() => {
        loadCampaign();
    }, [usr_session_ctx.session_info.uuid_current_opt_campaign]);


    function isCampaignOnModifyByOtherUser(uuid_opt_campaign) {
        // Return the fetch promise so it can be awaited
        return fetch(`${SERVER_URL}/current_opt_campaign/is_under_update_by_other_user/`, { 
            method: 'POST',
            headers: {
                'Content-Type':'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            },
            body: JSON.stringify(uuid_opt_campaign)
        })
        .then((res) => {
            if (!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((data) => {
            return data.data; // Return the actual data here
        })
        .catch((err) => {
            setException(true);
            setIsLoading(false);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            return null; // Return a default value in case of error
        });
    }



    useEffect( () => {
        if(usr_session_ctx.session_info.on_update_campaign.uuid_experimental_setup !== ''){
            setOnUpdate(true)
        }
        else{setOnUpdate(false)}
    }, [usr_session_ctx.session_info.on_update_campaign.uuid_experimental_setup]);

    // ----------- Define Navigation Bar to switch between viewer modes: Experimental Setup, Design Space, Objective

    function selectWindowMode(event){
        event.preventDefault();
        setWindowSelection(event.target.id);
        setIsEditor(false);
    }

    async function handleSessionUpdateOnModifyCampaignSetup(){
        const updatedSessionInfo = SetSessionInfo_ModifyCampaignObjects(usr_session_ctx, 
                                                                        campaignObjects.uuid_experimental_setup,
                                                                        campaignObjects.uuid_design_space,
                                                                        campaignObjects.uuid_objective,
                                                                        true,
                                                                        true,
                                                                        true);
        usr_session_ctx.session_info = updatedSessionInfo;  
        setIsLoading(true);  
        try{                                                          
            let session_update = { key: 'session_info', value: updatedSessionInfo };
            const response2 = await fetch(`${SERVER_URL}/user_session/update_field/`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            },
            body: JSON.stringify(session_update)
            });
            if (!response2.ok) {
                throw new Error(`HTTP error ${response2.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
        setIsLoading(false);
    }


    async function handleSessionUpdateOnSaveWorkflow( majorChangeDesignSpace, 
                                                      majorChangeObjective,
                                                      objects){
        // update SessionInfo - ExperimentalSetup is validated; validation status of DesignSpace and Objectives remain unchanged, unless majurChanges have been detected that 
        // may result in invalid DesignSpace/Objectives -> in this case the status of DesignSpace/Objectives is set to unvalidated
        let valid_exp_setup = true;
        let valid_design_space = usr_session_ctx.session_info.on_update_campaign.validated_design_space;
        let valid_objective = usr_session_ctx.session_info.on_update_campaign.validated_objective;
        if (majorChangeDesignSpace) { valid_design_space = false;}
        if (majorChangeObjective) { valid_objective = false;}

        const updatedSessionInfo = SetSessionInfo_ModifyCampaignObjects(usr_session_ctx, 
                                            campaignObjects.uuid_exp_setup,
                                            campaignObjects.uuid_design_space, 
                                            campaignObjects.uuid_objective,
                                            valid_exp_setup,
                                            valid_design_space,
                                            valid_objective);
        usr_session_ctx.session_info = updatedSessionInfo;                                                                    
        let session_update = { key: 'session_info', value: updatedSessionInfo };
        const response2 = await fetch(`${SERVER_URL}/user_session/update_field/`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'auth0_user': user.sub,
            'uuid_tenant': usr_session_ctx.uuid_tenant
            },
        body: JSON.stringify(session_update)
            });
        if (!response2.ok) {
            throw new Error(`HTTP error ${response2.status}`);
        }
    }

    async function handleSessionUpdateOnSaveDesignSpace(objects){
        let valid_exp_setup = usr_session_ctx.session_info.on_update_campaign.validated_experimental_setup;
        let valid_design_space = true;
        let valid_objective = usr_session_ctx.session_info.on_update_campaign.validated_objective;
        const updatedSessionInfo = SetSessionInfo_ModifyCampaignObjects(usr_session_ctx, 
                                                                        campaignObjects.uuid_experimental_setup,
                                                                        campaignObjects.uuid_design_space, 
                                                                        campaignObjects.uuid_objective,
                                                                        valid_exp_setup,
                                                                        valid_design_space,
                                                                        valid_objective);
        usr_session_ctx.session_info = updatedSessionInfo;                                                                    
        let session_update = { key: 'session_info', value: updatedSessionInfo };
        const response2 = await fetch(`${SERVER_URL}/user_session/update_field/`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'auth0_user': user.sub,
            'uuid_tenant': usr_session_ctx.uuid_tenant
        },
        body: JSON.stringify(session_update)
        });
        if (!response2.ok) {
            throw new Error(`HTTP error ${response2.status}`);
        }
    }

    async function handleSessionUpdateOnSaveObjective(objects){
        let valid_exp_setup = usr_session_ctx.session_info.on_update_campaign.validated_experimental_setup;
        let valid_design_space = usr_session_ctx.session_info.on_update_campaign.validated_design_space;
        let valid_objective = true;
        const updatedSessionInfo = SetSessionInfo_ModifyCampaignObjects(usr_session_ctx, 
                                                                        campaignObjects.uuid_experimental_setup,
                                                                        campaignObjects.uuid_design_space, 
                                                                        campaignObjects.uuid_objective,
                                                                        valid_exp_setup,
                                                                        valid_design_space,
                                                                        valid_objective);
        usr_session_ctx.session_info = updatedSessionInfo;                                                                    
        let session_update = { key: 'session_info', value: updatedSessionInfo };
        const response2 = await fetch(`${SERVER_URL}/user_session/update_field/`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'auth0_user': user.sub,
            'uuid_tenant': usr_session_ctx.uuid_tenant
        },
        body: JSON.stringify(session_update)
        });
        if (!response2.ok) {
            throw new Error(`HTTP error ${response2.status}`);
        }
    }
    


    async function handleResetSessionInfo(){
        const updatedSessionInfo = SetSessionInfo_ResetModifyCampaignObjects(usr_session_ctx);
        usr_session_ctx.session_info = updatedSessionInfo;                                                                    
        let session_update = { key: 'session_info', value: updatedSessionInfo };
        const response2 = await fetch(`${SERVER_URL}/user_session/update_field/`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'auth0_user': user.sub,
            'uuid_tenant': usr_session_ctx.uuid_tenant
        },
        body: JSON.stringify(session_update)
        });
        if (!response2.ok) {
            throw new Error(`HTTP error ${response2.status}`);
        }
    }
    
    async function handleResetSessionInfoDeleteCampaign(){
        const updatedSessionInfo = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
        usr_session_ctx.session_info = updatedSessionInfo;                                                                    
        let session_update = { key: 'session_info', value: updatedSessionInfo };
        const response2 = await fetch(`${SERVER_URL}/user_session/update_field/`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'auth0_user': user.sub,
            'uuid_tenant': usr_session_ctx.uuid_tenant
        },
        body: JSON.stringify(session_update)
        });
        if (!response2.ok) {
            throw new Error(`HTTP error ${response2.status}`);
        }
    }


    async function selectModify(){
        const num_cycles = campaign.optimization_cycles.length;
        if (num_cycles > 0){
            setShowCycleExistPopup(true)
        }
        else {
            const is_updated_by_other = await isCampaignOnModifyByOtherUser(campaign.uuid);
            if (is_updated_by_other.is_under_update === true){
                setSetupUpdatedBy(is_updated_by_other.under_update_by)
            }
            else {
                setOnUpdate(true);
                handleSessionUpdateOnModifyCampaignSetup();
                markCampaignUnderUpdate();
            }
        }
    }

    async function markCampaignUnderUpdate(){
        setIsLoading(true);  
        try{                                                          
            let uuids = {uuid_project: usr_session_ctx.session_info.uuid_current_project,
                         uuid_opt_campaign: campaign.uuid }
            const response2 = await fetch(`${SERVER_URL}/current_opt_campaign/mark_setup_under_update/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            },
            body: JSON.stringify(uuids)
            });
            if (!response2.ok) {
                throw new Error(`HTTP error ${response2.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
        setIsLoading(false);
    }



    async function unmarkCampaignUnderUpdate(){
        setIsLoading(true);  
        try{                                                          
            let uuids = {uuid_project: usr_session_ctx.session_info.uuid_current_project,
                uuid_opt_campaign: campaign.uuid }
            const response2 = await fetch(`${SERVER_URL}/current_opt_campaign/unmark_setup_under_update/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            },
            body: JSON.stringify(uuids)
            });
            if (!response2.ok) {
                throw new Error(`HTTP error ${response2.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
        setIsLoading(false);
    }



    async function selectModifyAsNew(){
        const uuid_created_objects = await cloneCampaign()
        setOnCloneCreatedObjects(uuid_created_objects)
        setPopupSuccessullyCloned(true)
    }


    async function handleMarkCurrent(){

        const updatedSessionInfo = SetSessionInfo_OnMarkCurrentOptCampaign(usr_session_ctx, 
                                                                           onCloneCreatedObjects.uuid_opt_campaign_new);
        usr_session_ctx.session_info = updatedSessionInfo;  
        setIsLoading(true);  
        try{                                                          
            let session_update = { key: 'session_info', value: updatedSessionInfo };
            const response2 = await fetch(`${SERVER_URL}/user_session/update_field/`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            },
            body: JSON.stringify(session_update)
            });
            if (!response2.ok) {
                throw new Error(`HTTP error ${response2.status}`);
            }
            setPopupSuccessullyCloned(false);
            setOnCloneCreatedObjects({});
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }

    async function cloneCampaign(){
        // API Backend Call
        setIsLoading(true);  
        try{                                                          
            let data = { uuids_campaign2clone: campaign.uuid,
                         uuid_project: usr_session_ctx.session_info.uuid_current_project
             };
            const response = await fetch(`${SERVER_URL}/current_project/clone_opt_campaign_setup/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            },
            body: JSON.stringify(data)
            });
            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
            else{
                const responseData = await response.json();
                const uuid_created_objects = responseData.data
                setIsLoading(false);
                return uuid_created_objects
            }
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }


        // current_project/clone_opt_campaign/
        // setPopupCloneSuccess(true)  
        //  -> popup says mark as current? or 

    }




    function onSaveCampaign(){
        // check if DesignSpace has been validated
        let valid = true;
        let validation_msg = []
        if (!usr_session_ctx.session_info.on_update_campaign.validated_design_space) { 
            valid=false;
            validation_msg.push({msg:'Design Space requires (re)validation', action:onValidateDesignSpace});
        }
        if (!usr_session_ctx.session_info.on_update_campaign.validated_objective) { 
            valid=false;
            validation_msg.push({msg:'Objective requires (re)validation', action:onValidateObjective});
        }
        if (!valid) {
            setValidationWindow(!valid);
            setValidationMessage(validation_msg);
        }
        else {
            handleSaveCampaign(); 

        }
    }


    async function handleSaveCampaign(){
        // Create Campaign, then update session
        await handleResetSessionInfo();
        await unmarkCampaignUnderUpdate();
        setShowCreateSuccess(true);
    }

    async function onDeleteCampaign(){
        setPopupDelete(true);
        await unmarkCampaignUnderUpdate();
    }


    async function deleteCampaign(){
        setIsLoading(true);  
        try{                    
            let uuids = {prj_uuid: usr_session_ctx.session_info.uuid_current_project,
                         campaign_uuid: campaign.uuid}
           
            const response = await fetch(`${SERVER_URL}/current_project/delete_campaign/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'auth0_user': user.sub,
                            'uuid_tenant': usr_session_ctx.uuid_tenant
                        },
                        body: JSON.stringify(uuids)
            });
            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
        setIsLoading(false);
    }


    async function handleDeleteCampaign(){
        await deleteCampaign();
        await handleResetSessionInfo();
        await handleResetSessionInfoDeleteCampaign();
        setCurrentCampaignExists(false);
        setPopupDelete(false);
    }


    function onValidateDesignSpace(){
        setWindowSelection('DesignSpace');
        setIsEditor(true);
        setValidationWindow(false);
        setValidationMessage([]);
    }

    function onValidateObjective(){
        setWindowSelection('Objective');
        setIsEditor(true);
        setValidationWindow(false);
        setValidationMessage([]);
    }

    function handleExitValidation(){
        setValidationWindow(false);
        setValidationMessage([]);
    }


    let classEW = 'black';
    let classDS = 'black';
    let classO = 'black';

    let viewer = (<></>);

    if (windowSelection === 'ExperimentalWorkflow' && campaignObjects){
        classEW = 'selectionLink selected';
        classDS = 'selectionLink';
        classO = 'selectionLink';
        viewer=(<>
                <WorkflowViewer uuid_experimental_setup={campaignObjects.uuid_experimental_setup} 
                                width={layout.main} 
                                height={canvasSize.height-80} 
                                hideActionPanel={true}/>
            </>);
        if(onUpdate){
            // let cycleId = campaign.optimization_cycles.length-1;
            // let cycleSetupPrev = {}
            // if (cycleId > 0) {
            //     cycleSetupPrev = campaign.optimization_cycles[cycleId-1].campaign_setup
            // }
            viewer=(<>
            <div style={{marginBottom:'-10px'}}></div>
                <WorkflowViewer uuid_experimental_setup={campaignObjects.uuid_experimental_setup} 
                                width={layout.main} 
                                height={canvasSize.height-120} 
                                onEdit={() => {setIsEditor(true)}}
                                />
            </>);
            if(isEditor) {
                viewer=(<>
                    <div style={{marginBottom:'-10px'}}></div>
                                <WorkflowEditor campaign_objects={campaignObjects}
                                    width={layout.main}
                                    height={canvasSize.height-180}
                                    exit={() => {setIsEditor(false)}}
                                    handleSessionUpdate={handleSessionUpdateOnSaveWorkflow}
                                    />
                    </>);
            }
        }
    }

    if (windowSelection === 'DesignSpace' && campaignObjects){
        classEW = 'selectionLink';
        classDS = 'selectionLink selected';
        classO = 'selectionLink';
        viewer=(<>
            <DesignSpaceViewer campaign_objects={campaignObjects}
                               width={layout.main}
                               height={canvasSize.height-80}
                               validated={true}
                               hideActionPanel={true}/>
        </>);
        if(onUpdate){
            viewer=(<>
                <div style={{marginBottom:'-10px'}}></div>
                    <DesignSpaceViewer campaign_objects={campaignObjects}
                                    width={layout.main} 
                                    height={canvasSize.height-120} 
                                    onEdit={() => {setIsEditor(true)}}
                                    validated={usr_session_ctx.session_info.on_update_campaign.validated_design_space}
                                    />
                </>);
            if(isEditor) {
                viewer=(<>
                    <div style={{marginBottom:'-10px'}}></div>
                                <DesignSpaceEditor campaign_objects={campaignObjects}
                                    width={layout.main}
                                    height={canvasSize.height-180}
                                    exit={() => {setIsEditor(false)}}
                                    handleSessionUpdate={handleSessionUpdateOnSaveDesignSpace}
                                    validated={usr_session_ctx.session_info.on_update_campaign.validated_design_space}
                                    handleSessionUpdateOnSaveWorkflow={handleSessionUpdateOnSaveWorkflow}
                                    />
                    </>);
            }
        }
    }

    if (windowSelection === 'Objective' && campaignObjects){
        classEW = 'selectionLink';
        classDS = 'selectionLink';
        classO = 'selectionLink selected';
        viewer=(<>
            <ObjectiveViewer   campaign_objects={campaignObjects} 
                               width={layout.main}
                               height={canvasSize.height-80}
                               validated={true}
                               hideActionPanel={true}/>
        </>);
        if(onUpdate){
            viewer=(<>
                <div style={{marginBottom:'-10px'}}></div>
                <ObjectiveViewer campaign_objects={campaignObjects}
                            width={layout.main} 
                            height={canvasSize.height-120} 
                            onEdit={() => {setIsEditor(true)}}
                            validated={usr_session_ctx.session_info.on_update_campaign.validated_objective}
                            />
            </>);
            if(isEditor) {
                viewer=(<>
                    <div style={{marginBottom:'-10px'}}></div>
                    <ObjectiveEditor campaign_objects={campaignObjects}
                            width={layout.main}
                            height={canvasSize.height-180}
                            exit={() => {setIsEditor(false)}}
                            handleSessionUpdate={handleSessionUpdateOnSaveObjective}
                            validated={usr_session_ctx.session_info.on_update_campaign.validated_objective}
                            handleSessionUpdateOnSaveWorkflow={handleSessionUpdateOnSaveWorkflow}
                            />
                </>);
            }
        }
    }


    function handleLoad(){
        navigate('/optimization_campaigns');
    }

    function handleOnCreate(){
        navigate('/campaign_builder');
    }


    async function onChangeTitle(event){
        const campaign_title = event.target.value
        let updated_campaign = {...campaign}
        updated_campaign.title = campaign_title
        setCampaign(updated_campaign);
    }

    async function onSaveTitle(){
        setIsLoading(true);
        try{
            let data = { title: campaign.title, 
                         uuid_project: usr_session_ctx.session_info.uuid_current_project,
                         uuid_opt_campaign: campaign.uuid };
            let headers = {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/update_campaign_title/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(data)
            });
            if(response.ok){
                await response.json();
                setEditCampaignTitle(false)
                setIsLoading(false);
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }

    // -------------------- Create Main Window -----------------------------------------------
    let mainWindow = (<MainWindow width={layout.main} />);


    if (!isLoading && !Exception && broadcastProject.length === 0 && broadcastCampaign.length === 0){
        // if no workflow is selected or created
        if (!currentCampaignExists) { 
            mainWindow = (<>
                <MainWindow width={layout.main} >
                    <div style={{fontSize:'18px', position:'relative', textAlign:'center', height:'fit-content', marginTop:'50px', width:'100%'}} >
                        There is no optimization campaign in focus. <br />Create or load an optimization campaign.
                    </div>  
                    <div style={{position: 'relative', display: 'flex', gap:'20px', justifyContent:'center', marginTop:'25px', left:'3%', width:'94%'}}>
                        <button className={'actionButton'} style={{width:'150px'}} onClick={handleOnCreate} >Create Campaign</button>
                        <button className={'actionButton'} style={{width:'150px', marginRight:'0px'}} onClick={handleLoad}>Load Campaign</button>
                    </div>                
                </MainWindow>
            </>);
        }

        else if (!validationWindow && !popupDelete && !showCreateSuccess && currentCampaignExists && !popupSuccessullyCloned) { 
            
            
            mainWindow = (<>
                <MainWindow width={layout.main} >
                <div style={{display:'flex', flexDirection: 'row', alignItems: 'center', gap: '5px'}}>
                {editCampaignTitle ? (<>
                    <button className='tableButton' 
                            style = {{position:'relative', marginLeft: '3%', width:'35px', marginBottom: '-20px', marginRight: '-3%'}}
                            onClick = {onSaveTitle}>
                                save
                    </button>
                    <input id='title' style = {{'marginTop': '20px', 'marginBottom': '0px', 'border':'none', 'outline':'none', 'padding':'5px', position: 'relative',
                                                'borderLeft':'0.5px solid var(--aixelo-gray-light)', 'fontSize': '24px', 'fontWeight':'bold', left:'3%', width:'94%'}}
                                                onChange = {onChangeTitle} value={campaign.title} autoComplete="off" type="text" placeholder="Enter Campaign Title"  name="project_title" /> 
                    </>
                ) : (<>
                    <button className='tableButton' 
                            style = {{position:'relative', marginLeft: '3%', width:'35px', marginBottom: '-20px', marginRight: '-3%'}}
                            onClick = {()=>{setEditCampaignTitle(true)}}>
                                edit
                    </button>
                    <p style = {{position:'relative', 'marginTop': '20px', 'marginBottom': '0px', 'border':'none', 'outline':'none', 'padding':'0px', 
                            'fontSize': '24px', 'fontWeight':'bold', left:'3%', width:'fit-content'}} >
                                
                        Campaign Title: {campaign.title}
                    </p>
                    </>
                )}
                </div>    
                <div style = {{marginLeft: '3%', marginTop:'5px', marginBottom: '0px', fontSize: '16px', position: 'relative', width:'fit-content'}} >
                                Campaign Uuid: {campaign.uuid}
                </div>

                {!isEditor ? (
                    <>
                    <div style={{position:'relative', left:'5%', top:'12px', display:'flex', gap:'10px', marginTop:'5px', zIndex:'100', width:'fit-content'}}>        
                        <button id='ExperimentalWorkflow' className={classEW} onClick={selectWindowMode} >Experimental Workflow</button>
                        <button id='DesignSpace' className={classDS} onClick={selectWindowMode}>Design Space</button>
                        <button id='Objective'className={classO} onClick={selectWindowMode}>Objective</button>
                    </div>     
                    <div className = {classes.inner_canvas} style={{height:canvasSize.height-160, paddingTop:'20px'}}>
                        {viewer}
                    </div>
                    </> ) : (
                        <div className = {classes.inner_canvas} style={{height:canvasSize.height-160, border: 'none', paddingTop:'20px'}}>
                        {viewer}
                    </div>
                    )}
                {!isEditor && (
                <div style={{ position: 'relative', display: 'flex', marginLeft: '3%', marginTop: '18px', marginBottom: '18px', height: 'fit-content', width: 'fit-content' }}>
                    {!onUpdate ? (
                        <>
                            <button className={'actionButton'} style={{ width: '210px', left: '3%' }} onClick={selectModify}>Modify Setup</button> 
                            <button className={'actionButton'} style={{ width: '210px', left: '3%' }} onClick={selectModifyAsNew}>Clone as New Campaign</button>
                        </>
                    ) : (
                        <>
                            <button className={'actionButton'} style={{ width: '180px', left: '3%' }} onClick={onSaveCampaign}>Save Campaign</button> 
                            <button className={'actionButton'} style={{ width: '180px', left: '3%' }} onClick={onDeleteCampaign}>Delete Campaign</button>
                        </>
                    )}
            </div>
            )}
                </MainWindow>
            </>);
            if(showCycleExistPopup){
                mainWindow = (<>
                    <MainWindow width={layout.main} >
                        <InfoPopup ypos={'60px'} handleOk={()=>{setShowCycleExistPopup(false);
                                                                setIsEditor(false);
                                                                setOnUpdate(false);
                                                                    } } >
                        This optimization campaign includes optimization cycles. For compatibility and
                        consistency, <strong>please apply any desired modification directly within the Optimization Cycle.</strong>
                        </InfoPopup>
                    </MainWindow>
                    </>);

            }

            if(setupUpdatedBy !== ''){
                mainWindow = (<>
                    <MainWindow width={layout.main} >
                    <div className = {classes2.yes_no_popup} style = { {marginTop: '60px'} } >
                        <div style = {{height: 'min-content', marginTop: '20px', marginBottom: '20px', width:'80%', textAlign: 'center', position: 'relative', left: '50%', transform: 'translate(-50%,0% )'}}>
                            <div > The active campaign setup is currently beeing updated by user {setupUpdatedBy}. </div>
                        </div>
                    </div>
                    </MainWindow>
                    </>);
            }
        }

        else if(validationWindow && !popupDelete && !showCreateSuccess && !popupSuccessullyCloned) {
        
            let action_panel = (
                <>
                    <div style={{marginTop:'25px'}}>
                        <div style={{marginLeft:'20px', marginBottom:'5px', fontSize:'14px'}}>Feel free to click 'Exit' to fix inconsistencies directly in the respective editor(s).</div>
                        <div style={{display:'flex', margin:'0px'}}>
                            <button id='validate_button' className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleExitValidation}>Exit</button>
                        </div>
                    </div>
                </>
                );

            let show_validations = (<>
                                        <div style={{position: 'relative', marginLeft:'20px', marginTop:'25px', height:'fit-content', width:`${layout.main * 0.95 - 60}px`, overflow:'auto'}}>
                                            <CampaignValidationTable validationMessage={validationMessage}/>
                                        </div>
                                    </>);
            let editor = (<>
                        <div className = {'builder_canvas'} style={{height:`${canvasSize.height-155}px`}} >
                            <h3 style={{marginTop:'10px', marginLeft:'20px', marginBottom:'10px', padding:'0px', color:'var(--aixelo-red)'}}>Campaign Validation</h3>
                            <div style={{marginLeft:'20px', marginBottom:'0px', fontSize:'14px'}}>Following issues have been detected.</div>
                            {show_validations}
                            {action_panel}
                        </div>
                    </>);

        mainWindow = (<>
            <MainWindow width={layout.main} >
                {editor}
            </MainWindow>
            </>);
        }
   
        else if(showCreateSuccess && !popupDelete && !popupSuccessullyCloned){
            let editor = (<>
                <div className = {'builder_canvas'} >
                    <InfoPopup ypos={'60px'} handleOk={()=>{setShowCreateSuccess(false)}} >
                            The campaign setup has been successfully updated!
                    </InfoPopup>  
                </div>
            </>);
            mainWindow = (<>
                <MainWindow width={layout.main} >
                    {editor}
                </MainWindow>
                </>);
        }

        else if(!showCreateSuccess && popupDelete && !popupSuccessullyCloned){
            let editor = (<>
                <div className = {'builder_canvas'} >
                <YesNoPopup ypos={'60px'} handleNo={()=>{setPopupDelete(false);}} handleYes={handleDeleteCampaign}>  
                                    Are you sure to permanently delete this campaign uuid:{campaign.uuid}?
                </YesNoPopup> 
                </div>
            </>);
            mainWindow = (<>
                <MainWindow width={layout.main} >
                    {editor}
                </MainWindow>
                </>);
        }

        else if(!showCreateSuccess && popupSuccessullyCloned){
            let editor = (<>
                <div className = {'builder_canvas'} >
                <YesNoPopup ypos={'60px'}
                            handleNo={()=>{setPopupSuccessullyCloned(false); 
                                        setOnCloneCreatedObjects({});
                            }} 
                            handleYes={handleMarkCurrent}>  
                    Successuflly cloned the campaign setup as new campaign (uuid:{onCloneCreatedObjects.uuid_opt_campaign_new})<br/><br/>
                    Created campaign setup objects:
                    <div style={{textAlign: 'left'}}>
                        <ul>
                            <li style={{marginBottom:'5px'}}>ExperimentalSetup (uuid: {onCloneCreatedObjects.uuid_cloned_exp_setup})</li>
                            <li style={{marginBottom:'5px'}}>DesignSpace (uuid: {onCloneCreatedObjects.uuid_cloned_design_space})</li>
                            <li> Objective (uuid: {onCloneCreatedObjects.uuid_cloned_objective})</li>
                        </ul>
                    </div>
                    Do you want to load the created campaign as current campaign?
                </YesNoPopup> 
                </div>
            </>);
            mainWindow = (<>
                <MainWindow width={layout.main} >
                    {editor}
                </MainWindow>
                </>);
        }
    }

    if (!isLoading && !Exception && broadcastCampaign.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={onOkBroadcastCampaign} >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastCampaign.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }

    if (!isLoading && !Exception && broadcastProject.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastProject(prevBroadcast => []); navigate('/')} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastProject.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }

    if (isLoading && !Exception) {   
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </MainWindow>
            </>);
       }


    // Exection and Error Messeges Get Priority and Are Evaluated Before Anything els
    if(Exception){
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <DisplayException>
                        {ExceptionMessage}
                    </DisplayException>  
                </MainWindow>
            </>);
       }


// ------------------ Return All Components ----------------------------

    // Show Sidebar, MainWindow and ChatWindow
    return(
        <>
        <div style={{position:'relative', display:'grid', gridTemplateColumns: 'auto auto auto', overflow: 'hidden', left:`${APP_WINDOW_CONFIG.OFFSET_WINDOW_LEFT_PX}px`, top:`${APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX}px`, height:canvasSize.height, width:'100%'}}>
            {sidebar}
            {mainWindow}
            <ChatWindow width={layout.chat}/>
        </div>    
        </>
    );

}


export default PageCampaignSetup;